import React from "react";
import {Navigate, useParams} from "react-router-dom";

export function UserAccountInfoRedirect() {
    const {id} = useParams();
    if (!id) {
        return <Navigate to="/settings/userAccount/list" replace />;
    }
    return <Navigate to={`/settings/userAccount/list?selectedId=${id}`} replace />;
}

export function UserAccountDetailRedirect() {
    const {id} = useParams();
    if (!id) {
        return <Navigate to="/settings/userAccount/list" replace />;
    }
    return <Navigate to={`/settings/userAccount/list?selectedId=${id}`} replace />;
}

export function UserAccountCreateRedirect() {
    return <Navigate to="/settings/userAccount/list" replace />;
}
